import styled from 'styled-components';

import { Box } from '../../../box';

export const Skeleton = styled(Box)<{ isDark: boolean }>`
	height: 14px;
	width: 100%;
	border-radius: 4px;

	background-color: ${({ isDark }) => (isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.08)')};

	animation: pulse 1.6s ease-in-out infinite;

	@keyframes pulse {
		0% {
			opacity: 1;
		}
		50% {
			opacity: 0.55;
		}
		100% {
			opacity: 1;
		}
	}
`;
